"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[497],{

/***/ 6369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wI": function() { return /* binding */ AppProvider; },
  "mr": function() { return /* binding */ useAppState; }
});

// UNUSED EXPORTS: useAppDispatch

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/interfaces/context/appContextInterfaces.ts
var appContextInterfaces = __webpack_require__(4182);
;// CONCATENATED MODULE: ./src/reducers/companyReducer.ts


var companyReducer = function(state, action) {
    switch(action.type){
        case appContextInterfaces/* CompanyActionTypes.updateCompany */.i.updateCompany:
            {
                var updatedState = (0,_object_spread/* default */.Z)({}, state, action.payload);
                return updatedState;
            }
        case appContextInterfaces/* CompanyActionTypes.resetCompany */.i.resetCompany:
            {
                return null;
            }
        default:
            {
                return state;
            }
    }
};

// EXTERNAL MODULE: ./src/reducers/userReducer.ts
var userReducer = __webpack_require__(8112);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./src/utils/reducers.ts



// Stolen directly from https://github.com/the-road-to-learn-react/use-combined-reducers
// because the NPM installed version has a build error which prevents us using it.
var useCombinedReducers = function(combinedReducers) {
    // Global State
    var state = Object.keys(combinedReducers).reduce(function(acc, key) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, key, combinedReducers[key][0]));
    }, {});
    // Global Dispatch Function
    var dispatch = function(action) {
        return Object.keys(combinedReducers).map(function(key) {
            return combinedReducers[key][1];
        }).forEach(function(fn) {
            return fn(action);
        });
    };
    return [
        state,
        dispatch
    ];
};

;// CONCATENATED MODULE: ./src/hooks/AppContext.tsx







var defaultAppState = {
    user: {
        logged_in: false,
        view_bookings: false,
        company: null,
        location: null,
        cropped_name: "",
        email: "",
        favorite_posts: [],
        name: "",
        id: null,
        isInitialized: false
    },
    company: {}
};
var AppStateContext = /*#__PURE__*/ react.createContext(defaultAppState);
var AppDispatchContext = /*#__PURE__*/ react.createContext(undefined);
/**
 * App Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <AppProvider>
 *   <Component />
 * </AppProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useAppState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useAppDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ var AppProvider = function(props) {
    var company = props.company, children = props.children;
    var ref = (0,_sliced_to_array/* default */.Z)(useCombinedReducers({
        company: react.useReducer(companyReducer, company ? (0,_object_spread/* default */.Z)({}, company) : defaultAppState.company),
        user: react.useReducer(userReducer/* userReducer */.M, defaultAppState.user)
    }), 2), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useAppState = function() {
    var context = react.useContext(AppStateContext);
    if (context === undefined) {
        throw new Error("useAppState must be used within the AppProvider");
    }
    return context;
};
var useAppDispatch = function() {
    var context = react.useContext(AppDispatchContext);
    if (context === undefined) {
        throw new Error("useAppDispatch must be used within the AppProvider");
    }
    return context;
};
AppProvider.displayName = "AppProvider";
useAppState.displayName = "useAppState";
useAppDispatch.displayName = "useAppDispatch";



/***/ }),

/***/ 4182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UserActionTypes; },
/* harmony export */   "i": function() { return /* binding */ CompanyActionTypes; }
/* harmony export */ });
var UserActionTypes;
(function(UserActionTypes) {
    UserActionTypes["updateUser"] = "update_user";
    UserActionTypes["resetUser"] = "reset_user";
})(UserActionTypes || (UserActionTypes = {}));
var CompanyActionTypes;
(function(CompanyActionTypes) {
    CompanyActionTypes["updateCompany"] = "update_company";
    CompanyActionTypes["resetCompany"] = "reset_company";
})(CompanyActionTypes || (CompanyActionTypes = {}));


/***/ }),

/***/ 8112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ userReducer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4182);


var defaultState = {
    isInitialized: false,
    logged_in: false,
    view_bookings: false,
    company: null,
    location: null,
    cropped_name: "",
    email: "",
    favorite_posts: [],
    name: "",
    id: null
};
var userReducer = function(state, action) {
    switch(action.type){
        case interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_0__/* .UserActionTypes.updateUser */ .F.updateUser:
            {
                var updatedState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state, action.payload);
                return updatedState;
            }
        case interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_0__/* .UserActionTypes.resetUser */ .F.resetUser:
            {
                return defaultState;
            }
        default:
            {
                return state;
            }
    }
};


/***/ }),

/***/ 3628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SC": function() { return /* binding */ fetchCompanySuggestions; },
  "bG": function() { return /* binding */ fetchJobs; },
  "BT": function() { return /* binding */ fetchUser; },
  "V1": function() { return /* binding */ getJobRecommendations; }
});

// UNUSED EXPORTS: fetchApiCompanySuggestions, fetchApiUser, getSingleCompany

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/config.js
var next_config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/node-cache/index.js
var node_cache = __webpack_require__(7915);
var node_cache_default = /*#__PURE__*/__webpack_require__.n(node_cache);
// EXTERNAL MODULE: ./src/utils/axiosClient.ts
var axiosClient = __webpack_require__(6704);
;// CONCATENATED MODULE: ./src/mocks/mockSingleCompany.json
var mockSingleCompany_namespaceObject = JSON.parse('{"object":"company","id":"50475b3f-97dd-48ea-9b1e-00f9cd26d48f","legacy_id":1327,"logo":"https://assets.staging-themuse.com/uploaded/companies/1327/small_logo.png?v=1689715223","name":"The Muse","short_name":"themuse","description":"The Muse is a site that helps people navigate their entire career journey. It offers expert advice and an innovative job search experience that’s actually engaging and doesn’t suckd","short_description":"The Muse is a site that helps people navigate their entire career journey. It offers expert advice and an innovative job search experience that’s actually engaging and doesn’t suck","snapshot_photo":"https://assets.staging-themuse.com/uploaded/companies/1327/snapshot/8d6528e3-19b1-43c4-ba88-8c4b2ee2d798-2.jpg?v=1689715223","state":"live","size":"medium","employee_range":"51_200","brandbuilder_org":"themusemay","industries":[{"object":"company_industry","id":"2ba61e94-1cd8-407a-8cde-1851748d413c","name":"Biotechnology","code":"biotechnology"},{"object":"company_industry","id":"0ddb6e8a-ccdd-4332-8f8b-0732b8d90c53","name":"Healthcare","code":"healthcare"},{"object":"company_industry","id":"c52e0a69-b6f1-48f6-bf95-95bd8fb22ec3","name":"Social Good","code":"social_good"},{"object":"company_industry","id":"d96f1c98-a5aa-48cf-a6a8-1058130cf3fa","name":"Tech","code":"tech"}],"perks_and_benefits":{"health_and_wellness":{"name":"Health and Wellness","value":"health_and_wellness","perks":[{"object":"company_perk_or_benefit","id":"eb51c554-007d-4483-a95d-bfa5f8cc4afb","name":"Short-Term Disability","code":"short_term_disability"},{"object":"company_perk_or_benefit","id":"4a55bbd2-1558-4624-84ce-59b09d8fe6cb","name":"Rock Climbing Membership","code":"rock_climbing_membership"}]},"parental_benefits":{"name":"Parental Benefits","value":"parental_benefits","perks":[{"object":"company_perk_or_benefit","id":"2893be6b-e354-4f3f-aee3-16803997a47b","name":"Adoption Assistance Program","code":"adoption_assistance"}]},"work_flexibility":{"name":"Work Flexibility","value":"work_flexibility","perks":[{"object":"company_perk_or_benefit","id":"b68f7f55-2980-4d03-b09f-edccd2633f48","name":"Home Office Stipend","code":"home_office_stipend"},{"object":"company_perk_or_benefit","id":"4945f10d-03b3-4a1c-818c-57b2e39b43bb","name":"Flexible Work Hours","code":"flexible_work_hours"}]},"vacation_and_timeoff":{"name":"Vacation and Time Off","value":"vacation_and_timeoff","perks":[{"object":"company_perk_or_benefit","id":"83b168af-db61-4d0c-b02e-db954b6f7913","name":"Sabbatical","code":"sabbatical"},{"object":"company_perk_or_benefit","id":"1443987a-a551-4024-96e7-2b7cbdf4dfdd","name":"Personal/Sick Days","code":"personal_sick_days"},{"object":"company_perk_or_benefit","id":"57ec2697-391c-479a-823c-101c44f01bff","name":"Unlimited Vacation","code":"unlimited_vacation"},{"object":"company_perk_or_benefit","id":"ebe7aae8-5ffb-40d8-8f9a-c41b34b854be","name":"Paid Vacation","code":"paid_vacation"}]},"finance":{"name":"Financial and Retirement","value":"finance","perks":[{"object":"company_perk_or_benefit","id":"ebab0943-3cbc-4a7c-8563-3ec85e17f454","name":"Profit Sharing","code":"profit_sharing"}]},"office_life":{"name":"Office Life and Perks","value":"office_life","perks":[{"object":"company_perk_or_benefit","id":"35270856-fd57-40eb-9c7d-dfa2e31e14b9","name":"Company Outings","code":"company_outings"}]},"professional_development":{"name":"Professional Development","value":"professional_development","perks":[{"object":"company_perk_or_benefit","id":"03031559-d881-4a84-ae85-f78d57b85048","name":"Work Visa Sponsorship","code":"work_visa_sponsorship"}]},"diversity_and_inclusion":{"name":"Diversity and Inclusion","value":"diversity_and_inclusion","perks":[{"object":"company_perk_or_benefit","id":"f3d3047b-c6c9-4beb-9447-eb6f94479c62","name":"Diversity, Equity, and Inclusion Program","code":"diversity_and_inclusion_program"},{"object":"company_perk_or_benefit","id":"7ca73a9c-fac0-4f93-b843-151e597678e7","name":"Founder led","code":"founder_led"},{"object":"company_perk_or_benefit","id":"4f4cb3b2-c5ab-42ba-9695-bfdc9848f26b","name":"Female founded/led","code":"female_led"},{"object":"company_perk_or_benefit","id":"0febf4b8-6a0f-441a-b982-3cb46e9f167d","name":"Latinx founded/led","code":"latinx_led"}]},"my_owen_benefit":{"name":"a real benefit","value":"my_owen_benefit","perks":[]}},"tags":[],"leadership_attributes":[{"object":"company_leadership_attributes","id":"f3d3047b-c6c9-4beb-9447-eb6f94479c62","name":"Diversity, Equity, and Inclusion Program","code":"diversity_and_inclusion_program"},{"object":"company_leadership_attributes","id":"7ca73a9c-fac0-4f93-b843-151e597678e7","name":"Founder led","code":"founder_led"},{"object":"company_leadership_attributes","id":"4f4cb3b2-c5ab-42ba-9695-bfdc9848f26b","name":"Female founded/led","code":"female_led"},{"object":"company_leadership_attributes","id":"0febf4b8-6a0f-441a-b982-3cb46e9f167d","name":"Latinx founded/led","code":"latinx_led"}],"diversity_and_inclusion_attributes":[{"object":"company_leadership_attributes","id":"f3d3047b-c6c9-4beb-9447-eb6f94479c62","name":"Diversity, Equity, and Inclusion Program","code":"diversity_and_inclusion_program"},{"object":"company_leadership_attributes","id":"7ca73a9c-fac0-4f93-b843-151e597678e7","name":"Founder led","code":"founder_led"},{"object":"company_leadership_attributes","id":"4f4cb3b2-c5ab-42ba-9695-bfdc9848f26b","name":"Female founded/led","code":"female_led"},{"object":"company_leadership_attributes","id":"0febf4b8-6a0f-441a-b982-3cb46e9f167d","name":"Latinx founded/led","code":"latinx_led"}],"brandblocks_enabled":false,"conversion_tracking_enabled":true,"search_boost":"none","job_premium_features_enabled":true,"job_on_profile_display_enabled":true,"job_alerts_enabled":true,"job_search_boost":"none","job_tracking_token":null,"job_prepended_tracking_token":null,"package":null,"client_tier":null,"direct_apply_vendor":null,"merge_account_token":null}');
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
;// CONCATENATED MODULE: ./src/utils/constants.ts
// Months array for date formatting
var months = (/* unused pure expression or super */ null && ([
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
]));
// Character limit for suggestion api
var suggestionApiQueryMaxlength = 70;
// Character limit for job search api
var jobQueryCompanyShortnameMaxlength = 50;
var jobQueryJobShortnameMaxlength = 250;
var jobSearchQueryMaxlength = 40;


// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
;// CONCATENATED MODULE: ./src/utils/orm.ts
/**
 * Compresses a company object by removing unused properties and filtering out empty arrays.
 * Maps specific properties to extract only their names.
 * Specifically
 * * Perks and Benefits should only have name value and perks.
 * * Each perk array should only be the names.
 * * Industries should only be the names.
 * * leadership_attributes should only be the names.
 *
 * @param company - The input object representing a company.
 * @returns A compressed version of the company object with removed properties, and filtered arrays.
 */ var compressedCompany = function(company) {
    var id = company.id, legacy_id = company.legacy_id, logo = company.logo, name = company.name, short_name = company.short_name, description = company.description, short_description = company.short_description, snapshot_photo = company.snapshot_photo, state = company.state, size = company.size, employee_range = company.employee_range, industries = company.industries, perks_and_benefits = company.perks_and_benefits, leadership_attributes = company.leadership_attributes;
    var PerkBucket = {};
    // Remove all the unused stuff.
    Object.keys(perks_and_benefits).filter(Boolean).forEach(function(bucket) {
        if (!perks_and_benefits[bucket].perks.length) return;
        PerkBucket[bucket] = {
            name: perks_and_benefits[bucket].name,
            value: perks_and_benefits[bucket].value,
            perks: perks_and_benefits[bucket].perks.filter(Boolean).map(function(x) {
                return x.name;
            })
        };
    });
    return {
        id: id,
        legacy_id: legacy_id,
        logo: logo,
        name: name,
        short_name: short_name,
        description: description,
        short_description: short_description,
        snapshot_photo: snapshot_photo,
        state: state,
        size: size,
        employee_range: employee_range,
        industries: industries.filter(Boolean).map(function(x) {
            return x.name;
        }),
        perks_and_benefits: PerkBucket,
        leadership_attributes: leadership_attributes.filter(Boolean).map(function(x) {
            return x.name;
        })
    };
};


;// CONCATENATED MODULE: ./src/utils/api.ts













// Expire once a day, check every 5 minutes
var apiCache = new (node_cache_default())({
    stdTTL: 86400,
    checkperiod: 300
});
var getJobRecommendations = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, _publicRuntimeConfig, apiBase, apiRequestTimeoutMs, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiBase = _publicRuntimeConfig.apiBase, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs;
                    _ctx.next = 3;
                    return axiosClient/* axiosClient.get */.U.get("".concat(apiBase, "/recommendations"), {
                        timeout: apiRequestTimeoutMs
                    })["catch"](function(error) {
                        var msg = "Error requesting job at ".concat(apiBase, "/recommendations.");
                        var err = JSON.stringify((0,logging/* formatLog */.U)({
                            error: error
                        }));
                        console.error(msg, err);
                    }).then(function(res) {
                        return res === null || res === void 0 ? void 0 : res.data;
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getJobRecommendations() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Formatter for The Muse Jobs.
 * This is the default.
 */ var getFormattedQueryParams = function() {
    var queryParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return (0,_object_spread/* default */.Z)({}, queryParams, queryParams.query && {
        query: queryParams.query.substring(0, jobSearchQueryMaxlength)
    });
};
/**
 * Returns the Axios config for requesting Jobs from TheMuse.
 */ var getMuseJobsConfig = function(queryParams, cookies) {
    var ref = (0,next_config["default"])(), jobsApiHost = ref.serverRuntimeConfig.jobsApiHost;
    var ref1 = (0,next_config["default"])(), _publicRuntimeConfig = ref1.publicRuntimeConfig, apiBase = _publicRuntimeConfig.apiBase, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs;
    var path = (0,browser/* isBrowser */.jU)() ? "".concat(apiBase, "/jobs?limit=5") : "".concat(jobsApiHost, "/api/v2/search/jobs?limit=5");
    var formattedQueryParams = getFormattedQueryParams(queryParams);
    var museConfig = {
        method: "GET",
        url: path,
        headers: (0,browser/* isBrowser */.jU)() ? {} : {
            Cookie: cookies || ""
        },
        params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formattedQueryParams), {
            timeout: apiRequestTimeoutMs
        })
    };
    return museConfig;
};
/**
 * Request jobs directly from the backend API or proxied through the Next.js internal API.
 */ var fetchJobs = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(queryParams, cookies) {
        var axiosConfig, response, msg, err;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    axiosConfig = getMuseJobsConfig(queryParams, cookies);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return axios_default()(axiosConfig);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    msg = "Company Renderer was unable to request job results from ".concat(axiosConfig.url);
                    err = JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    }));
                    console.error(msg, err);
                    throw new Error(msg);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function fetchJobs(queryParams, cookies) {
        return _ref.apply(this, arguments);
    };
}();
var getSingleCompany = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(queryParams) {
        var ref, _publicRuntimeConfig, apiBase, apiRequestTimeoutMs, _serverRuntimeConfig, companyApiHost, companyApiToken, mockApiResponses, companyShortName, config, msg, path, cachedCompany, ref1, response, apiCompanyRequest, company;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiBase = _publicRuntimeConfig.apiBase, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, _serverRuntimeConfig = ref.serverRuntimeConfig, companyApiHost = _serverRuntimeConfig.companyApiHost, companyApiToken = _serverRuntimeConfig.companyApiToken, mockApiResponses = _serverRuntimeConfig.mockApiResponses;
                    companyShortName = queryParams.companyShortName;
                    config = {
                        timeout: apiRequestTimeoutMs,
                        headers: {
                            Authorization: "Bearer ".concat(companyApiToken)
                        }
                    };
                    if (!((companyShortName === null || companyShortName === void 0 ? void 0 : companyShortName.length) > jobQueryCompanyShortnameMaxlength)) {
                        _ctx.next = 6;
                        break;
                    }
                    msg = "Malformed Request: The companyShortName parameter exceeds maximum length of ".concat(jobQueryCompanyShortnameMaxlength, ".");
                    throw new Error(msg);
                case 6:
                    path = (0,browser/* isBrowser */.jU)() ? "".concat(apiBase, "/company/").concat(companyShortName) : "".concat(companyApiHost, "/api/v1/companies/").concat(companyShortName);
                    cachedCompany = apiCache.get(companyShortName);
                    if (!(cachedCompany === undefined)) {
                        _ctx.next = 23;
                        break;
                    }
                    ;
                    if (!mockApiResponses) {
                        _ctx.next = 14;
                        break;
                    }
                    _ctx.t0 = {
                        data: mockSingleCompany_namespaceObject
                    };
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.next = 16;
                    return axiosClient/* axiosClient.get */.U.get(path, config)["catch"](function(error) {
                        var msg = "Error requesting job at ".concat(path, ".");
                        var err = JSON.stringify((0,logging/* formatLog */.U)({
                            error: error
                        }));
                        console.error(msg, err);
                    });
                case 16:
                    _ctx.t0 = _ctx.sent;
                case 17:
                    response = _ctx.t0;
                    apiCompanyRequest = (ref1 = response) === null || ref1 === void 0 ? void 0 : ref1.data;
                    company = compressedCompany(apiCompanyRequest);
                    apiCache.set(companyShortName, company);
                    console.info("Cache refreshed, ".concat(companyShortName, " retrieved from API."));
                    return _ctx.abrupt("return", company);
                case 23:
                    console.info("Cache existing, ".concat(companyShortName, " retrieved from NodeCache."));
                    return _ctx.abrupt("return", cachedCompany);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSingleCompany(queryParams) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request the user.
 */ var fetchUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(axiosOptions) {
        var ref, _publicRuntimeConfig, apiRequestTimeoutMs, apiBase, config, path, response, msg;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, apiBase = _publicRuntimeConfig.apiBase;
                    config = (0,_object_spread/* default */.Z)({}, {
                        timeout: apiRequestTimeoutMs,
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }, axiosOptions);
                    path = "".concat(apiBase, "/user");
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return axios_default()(path, config);
                case 6:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](3);
                    msg = "Company Renderer was unable to request the user from ".concat(path, ".");
                    console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    })));
                    return _ctx.abrupt("return", null);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function fetchUser(axiosOptions) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request user from the service API.
 */ var fetchApiUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var oskarId, sessionId, axiosOptions, ref, _publicRuntimeConfig, apiRequestTimeoutMs, museApiHost, museHost, config, path, response, msg, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    oskarId = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "", sessionId = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "", axiosOptions = _args.length > 2 ? _args[2] : void 0;
                    ref = (0,next_config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, museApiHost = _publicRuntimeConfig.museApiHost, museHost = _publicRuntimeConfig.museHost;
                    config = (0,_object_spread/* default */.Z)({}, {
                        timeout: apiRequestTimeoutMs,
                        headers: {
                            "Content-Type": "application/json",
                            cookie: "oskar_id=".concat(oskarId, "; session_id=").concat(sessionId),
                            referer: museHost
                        }
                    }, axiosOptions);
                    path = "".concat(museApiHost, "/api/user");
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return axios_default()(path, config);
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    msg = "Company Renderer was unable to request the user from ".concat(path, ".");
                    console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    })));
                    return _ctx.abrupt("return", null);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    }));
    return function fetchApiUser() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request company suggestions.
 */ var fetchCompanySuggestions = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inputValue, axiosOptions) {
        var ref, _publicRuntimeConfig, apiRequestTimeoutMs, apiBase, path, response, msg, err;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, apiBase = _publicRuntimeConfig.apiBase;
                    path = "".concat(apiBase, "/company-suggestion/").concat(inputValue);
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return axios_default()(path, (0,_object_spread/* default */.Z)({}, axiosOptions, {
                        timeout: apiRequestTimeoutMs
                    }));
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    msg = "Error requesting company suggestions from ".concat(path);
                    err = JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    }));
                    console.error(msg, err);
                    return _ctx.abrupt("return", null);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function fetchCompanySuggestions(inputValue, axiosOptions) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request company suggestions from the service API.
 */ var fetchApiCompanySuggestions = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(query) {
        var ref, _serverRuntimeConfig, apiRequestTimeoutMs, jobsApiHost, queryObj, config, path, response, msg, err;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config["default"])(), _serverRuntimeConfig = ref.serverRuntimeConfig, apiRequestTimeoutMs = _serverRuntimeConfig.apiRequestTimeoutMs, jobsApiHost = _serverRuntimeConfig.jobsApiHost;
                    queryObj = query ? {
                        query: query
                    } : {};
                    config = {
                        params: (0,_object_spread/* default */.Z)({
                            type: "company_name"
                        }, queryObj),
                        timeout: apiRequestTimeoutMs
                    };
                    path = "".concat(jobsApiHost, "/api/v2/suggestions");
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return axios_default()(path, config);
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    msg = "Error requesting jobs from ".concat(path);
                    err = JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    }));
                    console.error(msg, err);
                    return _ctx.abrupt("return", null);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    }));
    return function fetchApiCompanySuggestions(query) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 6704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ axiosClient; }
/* harmony export */ });
/* harmony import */ var http__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2321);
/* harmony import */ var http__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(http__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8428);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(https__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);



var httpAgentConfig = {
    keepAlive: true,
    timeout: 5000,
    maxSockets: Infinity
};
var axiosClient = axios__WEBPACK_IMPORTED_MODULE_2___default().create({
    timeout: 5000,
    httpAgent: new (http__WEBPACK_IMPORTED_MODULE_0___default().Agent)(httpAgentConfig),
    httpsAgent: new (https__WEBPACK_IMPORTED_MODULE_1___default().Agent)(httpAgentConfig),
    maxRedirects: 10,
    maxContentLength: 50 * 1000 * 1000
});


/***/ }),

/***/ 7228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jU": function() { return /* binding */ isBrowser; }
/* harmony export */ });
/* unused harmony exports isMobile, parseQueryParamsToObject, getUserLatLng, shouldShowFeature, toggleWindowFreeze, getOptimizeData */
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);

/**
 * Are we currently within a browser.
 */ var isBrowser = function() {
    return  true && typeof window.document !== "undefined";
};
/**
 * Is the browser currently set to 768px or less wide.
 * Expects window.innerWidth;
 */ var isMobile = function() {
    return isBrowser() && window.innerWidth <= 768;
};
// https://stackoverflow.com/a/8649003
/**
 * Parses a query param string and returns an object of the values
 * @param query - valid string to parse
 */ var parseQueryParamsToObject = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var queryString = query;
    if (queryString && queryString[0] === "?") {
        queryString = queryString.substring(1);
    }
    try {
        return JSON.parse('{"'.concat(decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"'), '"}'));
    } catch (e) {
        return null;
    }
};
/**
 * Returns the user's lat,lng from session storage in an array.
 */ var getUserLatLng = function() {
    if (!isBrowser()) {
        return [
            null,
            null
        ];
    }
    var lat = parseFloat(window.sessionStorage.getItem("carmen_lat"));
    var lng = parseFloat(window.sessionStorage.getItem("carmen_lon"));
    return [
        lat,
        lng
    ];
};
/**
 * Take a name and determine if the feature should show or be hidden
 * based on environment variable.
 */ var shouldShowFeature = function(name) {
    var publicRuntimeConfig = getConfig().publicRuntimeConfig;
    var FEATURE_FLAGS = {
        example: "featureFlagExample"
    };
    if (FEATURE_FLAGS[name] && typeof publicRuntimeConfig[FEATURE_FLAGS[name]] !== "undefined") {
        return !(publicRuntimeConfig[FEATURE_FLAGS[name]] === "false");
    }
    return true;
};
var toggleWindowFreeze = function() {
    var style = document.body.style;
    if (style.overflow === "hidden") {
        style.height = "auto";
        style.overflow = "auto";
    } else {
        style.height = "100vh";
        style.overflow = "hidden";
    }
};
/**
 * Extracts Optimize experiment id and variant id from data layer
 *
 */ var getOptimizeData = function() {
    var allExperiments = [];
    if (isBrowser() && "dataLayer" in window) {
        var experiments = window.dataLayer.filter(function(x) {
            return typeof x === "object" && "experimentID" in x;
        });
        if (experiments.length > 0) {
            experiments.forEach(function(x) {
                allExperiments.push({
                    experiment_id: x.experimentID,
                    variant_id: x.variantID
                });
            });
        }
    }
    return allExperiments;
};


/***/ }),

/***/ 4453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ formatLog; }
/* harmony export */ });
/* unused harmony export axiosErrorToLogMap */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);



var axiosErrorToLogMap = {
    http: {
        url: "config.url",
        status_code: "response.status",
        method: "request.method"
    }
};
var LOG_STATUS = {
    INFO: "info",
    WARN: "warn",
    ERROR: "error"
};
/**
 * Formats the message key for the log e.g. HTTP GET /foo/bar
 * @example
 * const message = formatMessage("GET", "foo/bar");
 * console.log(message);
 */ var formatMessage = function(method, url) {
    return "HTTP ".concat(method, " ").concat(url);
};
/**
 * Returns the log level string based on the status code
 * @example
 * const logLevel = getLogLevel(500);
 * console.log(logLevel);
 */ var getLogLevel = function() {
    var statusCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 200, defaultLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : LOG_STATUS.INFO;
    switch(Math.floor(statusCode / 100)){
        case 5:
            return LOG_STATUS.ERROR;
        case 4:
            return LOG_STATUS.WARN;
        default:
            return defaultLevel;
    }
};
/**
 * Gets a nested value from on object via a string reference
 * @example
 * const nestedObject = { foo: { bar: 7 } };
 * const nestedValue = getNested(nestedObject, "foo.bar");
 * console.log(nestedValue);
 */ var getNested = function(theObject, path) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
    try {
        return path.replace("[", separator).replace("]", "").split(separator).reduce(function(obj, property) {
            return obj[property];
        }, theObject);
    } catch (err) {
        return undefined;
    }
};
/**
 * Creates a new object using the values in mappedObject and the
 * key references in the map. Essentially an object reducer.
 * @example
 * const mappableObject = { foo: { bar: 7 } };
 * const map = { baz: "foo.bar" };
 * const mappedObject = mappedObject(mappableObject, map);
 * console.log(mappedObject);
 */ var mapObj = function(mappedObject, map) {
    var newObject = {};
    // Traverse the object
    Object.keys(map).forEach(function(key) {
        var newObjectValue;
        if (typeof map[key] === "object") {
            newObjectValue = mapObj(mappedObject, map[key]);
        } else {
            newObjectValue = getNested((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, mappedObject), map[key]);
        }
        newObject[key] = newObjectValue;
    });
    return newObject;
};
/**
 * Uses values from a Koa context object and an optional error object
 * to create a formatted log object. Uses mapObj to translate to the
 * desired format. Takes an optional mapping argument to override the default.
 * @example
 * const formattedLog = formatLog(context, error);
 * console.log(formattedLog);
 */ var formatLog = function(format) {
    var context = format.context, error = format.error, _contextToLogMap = format.contextToLogMap, contextToLogMap = _contextToLogMap === void 0 ? axiosErrorToLogMap : _contextToLogMap;
    var contextValues = null;
    var logInfo = null;
    if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
        var ref;
        contextValues = mapObj((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, error), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, contextToLogMap));
        logInfo = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, contextValues), {
            level: getLogLevel((contextValues === null || contextValues === void 0 ? void 0 : (ref = contextValues.http) === null || ref === void 0 ? void 0 : ref.status_code) || error.status),
            message: formatMessage(contextValues.http.method || error.message, contextValues.http.url)
        });
    } else {
        var ref1 = context || {}, tmp = ref1.req, ref2 = tmp === void 0 ? {} : tmp, _method = ref2.method, method = _method === void 0 ? "" : _method, _url = ref2.url, url = _url === void 0 ? "" : _url, tmp1 = ref1.res, ref3 = tmp1 === void 0 ? {} : tmp1, _statusCode = ref3.statusCode, statusCode = _statusCode === void 0 ? 0 : _statusCode;
        contextValues = mapObj((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, context), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, contextToLogMap));
        logInfo = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, contextValues), {
            level: getLogLevel(statusCode),
            message: formatMessage(method, url)
        });
    }
    var errorValues = error ? {
        message: error.message,
        stack: error.stack,
        kind: error.name
    } : null;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, logInfo, errorValues && {
        error: errorValues
    });
};


/***/ })

}]);